"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInput = FileInput;
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _colors = require("@mui/material/colors");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const acceptedTypes = {
  '*': '*',
  image: 'image/*',
  csv: '.csv',
  gpx: '.gpx',
  geojson: '.geojson',
  shp: '.zip',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};
function FileInput(_ref) {
  let {
    disableCard,
    disabled,
    error,
    buttonLabel,
    type,
    file,
    disablePreview,
    emptyStateLabel,
    removeButtonLabel,
    removeIcon,
    savedFileName,
    size,
    onChange
  } = _ref;
  const [previewUrl, setPreviewUrl] = (0, _react.useState)();
  const inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (file && type === 'image') {
      if ('url' in file) setPreviewUrl(file.url);
    } else {
      setPreviewUrl(undefined);
    }
  }, [file]);
  function handleChange(_ref2) {
    let {
      target: {
        files
      }
    } = _ref2;
    const newFile = files?.[0];
    if (newFile && type === 'image') {
      setPreviewUrl(URL.createObjectURL(newFile));
    }
    onChange(newFile || file);
  }
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: [disableCard ? '' : 'card', error ? 'error' : ''].filter(Boolean).join(' ')
  }, /*#__PURE__*/_react.default.createElement(StyledHiddenInput, {
    accept: acceptedTypes[type],
    onChange: handleChange,
    onClick: _ref3 => {
      let {
        currentTarget
      } = _ref3;
      return currentTarget.value = '';
    },
    ref: inputRef,
    type: "file"
  }), /*#__PURE__*/_react.default.createElement(StyledName, {
    noWrap: true,
    color: !file && !savedFileName ? '#6B7280' : 'black',
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "subtitle1"
  }, file ? file.name : savedFileName ? savedFileName : emptyStateLabel || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.no_file_choosen"
  })), !disablePreview && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, previewUrl && /*#__PURE__*/_react.default.createElement(StyledThumbnail, {
    size: size,
    url: previewUrl
  }), file && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: removeButtonLabel || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.remove"
    })
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    marginLeft: "8px"
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    disabled: disabled,
    onClick: () => onChange(null),
    size: "small"
  }, removeIcon || /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  }))))), /*#__PURE__*/_react.default.createElement(StyledButton, {
    color: !error ? 'primary' : undefined,
    disabled: disabled,
    onClick: () => inputRef.current?.click(),
    size: size,
    style: error ? {
      borderColor: _colors.red[500],
      color: _colors.red[500]
    } : {},
    variant: "text"
  }, buttonLabel || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.choose",
    values: {
      context: type === '*' ? 'file' : type
    }
  })));
}
const Wrapper = _styledComponents.default.div`
  align-items: center;
  display: flex;

  &.card {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;

    &.error {
      border-color: ${_colors.red[500]};
    }
  }

  &:not(.card) {
    flex-grow: 1;
  }

  > button {
    flex-shrink: 0;
  }
`;
const StyledHiddenInput = _styledComponents.default.input`
  display: none;
`;
const StyledName = (0, _styledComponents.default)(_Typography2.default)`
  && {
    flex-grow: 1;
    margin: 0 16px;
  }
`;
const StyledThumbnail = _styledComponents.default.div`
  background-image: ${_ref4 => {
  let {
    url
  } = _ref4;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-shrink: 0;
  height: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'small' ? '30px' : '50px';
}};
  margin-left: 8px;
  width: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'small' ? '30px' : '50px';
}};
`;
const StyledButton = (0, _styledComponents.default)(_Button2.default)`
  max-height: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'small' ? '38px' : '54px';
}};
  height: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'small' ? '38px' : '54px';
}};

  && {
    border-left: 1px solid #c7cedc;
    background-color: #f6f7fb;
    text-transform: initial;
    padding: 0 24px;
    font-size: 1rem;
    border-radius: 0 4px 4px 0;
  }
`;